// extracted by mini-css-extract-plugin
export default {"section":"MapUzb_section__lWmzU","uzb":"MapUzb_uzb__0Bf6-","map2":"MapUzb_map2__qXnKX"};